import Card from '@/components/Card';
import DefaultContentTemplateTags from '../Tags';
import classNames from 'classnames';

export interface RelatedContent {
  title: string;
  description: string;
  author: string;
  link?: string;
  type: string;
  image: {
    url: string;
    alternativeText: string;
  };
  noImage?: boolean;
}
export default function DefaultContentTemplateRelatedContent({
  relatedContent,
  className,
  isDefaultContentTemplate = false,
}: {
  relatedContent: RelatedContent[];
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  if (!relatedContent || relatedContent.length === 0) return null;
  return (
    <>
      <h2
        className={classNames('text-sh-24 font-bold', className, {
          'my-0': isDefaultContentTemplate,
          'my-sh-30': !isDefaultContentTemplate,
        })}>
        Related content
      </h2>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {relatedContent.map((content) => {
          return (
            <Card
              noImage={content?.noImage}
              key={content.title}
              title={content.title}
              description={content.description}
              author={content.author}
              link={content.link}
              tags={<DefaultContentTemplateTags tags={[content.type]} className="!mb-2 !mt-0" />}
              image={{
                url: content?.image?.url,
                alternativeText: content?.image?.alternativeText,
              }}
            />
          );
        })}
      </div>
    </>
  );
}
